import React from 'react';
import { Shimmer } from '../Shimmer/Shimmer';
import {
  Container,
  PageHeader,
  CalculatorBox,
  InputRow,
  FlagCurrencyGroup,
  HorizontalLine,
  InfoBanner,
  DropdownRow,
  YouPayRow
} from './ShimmerSendMoneyCalculator.styles';
import { ShimmerSendMoneyCalculatorProps } from './ShimmerSendMoneyCalculator.types';

const ShimmerCurrencyInputRow = () => (
  <InputRow>
    <Shimmer width={140} height={40} borderRadius={6} />
    <FlagCurrencyGroup>
      <Shimmer circle width={24} height={24} />
      <Shimmer width={60} height={20} borderRadius={4} />
    </FlagCurrencyGroup>
  </InputRow>
);

export const ShimmerSendMoneyCalculator = ({ width, height }: ShimmerSendMoneyCalculatorProps) => {
  return (
    <Container $width={width} $height={height}>
      <PageHeader>
        <Shimmer width={180} height={22} />
        <Shimmer width={120} height={16} />
      </PageHeader>

      <CalculatorBox>
        <Shimmer width={70} height={14} />
        <ShimmerCurrencyInputRow />
        <Shimmer width={160} height={12} />

        <HorizontalLine />

        <Shimmer width={120} height={14} />
        <ShimmerCurrencyInputRow />
        <Shimmer width={130} height={12} />
      </CalculatorBox>

      <InfoBanner>
        <Shimmer circle width={16} height={16} />
        <Shimmer width={280} height={12} />
      </InfoBanner>

      <DropdownRow>
        <Shimmer width={120} height={12} />
        <Shimmer width="100%" height={48} borderRadius={8} />
      </DropdownRow>

      <DropdownRow>
        <Shimmer width={140} height={12} />
        <Shimmer width="100%" height={48} borderRadius={8} />
      </DropdownRow>

      <YouPayRow>
        <div>
          <Shimmer width={90} height={12} />
          <Shimmer width={130} height={22} style={{ marginTop: 6 }} />
        </div>
        <Shimmer width={50} height={14} />
      </YouPayRow>

      <Shimmer width="100%" height={48} borderRadius={24} />
    </Container>
  );
};
